export default "__VITE_ASSET__Ce8PnyGB__"